<template>
  <div class="footer">
    <div class="footer__btn">
      <button class="button square gray" @click="closeWindow()">취소</button>
    </div>
    <div class="footer__btn">
      <button
        v-show="this.$store.state.BizInfo.tabValue == 0"
        class="button square primary"
        :disabled="allowNextButton"
        @click="changeTab(1)"
      >
        다음
      </button>
      <button
        v-show="this.$store.state.BizInfo.tabValue == 1"
        class="button square white"
        @click="changeTab(0)"
      >
        이전
      </button>
      <button
        v-show="this.$store.state.BizInfo.tabValue == 1"
        class="button square primary"
        :disabled="allowUpdateButton"
        @click="clickUpdateBizInfo"
      >
        업데이트 신청
      </button>
    </div>
    <form v-show="false" id="resultForm">
      <input id="certifiedName" type="hidden" value />
      <input id="certifiedTel" type="hidden" />
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { create as createXml } from "xmlbuilder2";
import { updateBizInfo } from "@/api/niceApi.js";
import { TXVSREQPGMDIVCD, CPORCD } from "@/constant.js";

export default {
  name: "UpdateRequestFooter",
  computed: {
    ...mapGetters(["bizInfo"]),
    tabValue: {
      get() {
        return this.bizInfo.tabValue;
      },
      set(value) {
        this.$store.commit("BizInfo/SET_TABVALUE", value);
      },
    },
    allowNextButton() {
      return !(
        this.bizInfo.bizinfo.checkStatus == 1 ||
        this.bizInfo.fin1info.checkStatus == 1 ||
        this.bizInfo.fin2info.checkStatus == 1 ||
        this.bizInfo.fin3info.checkStatus == 1
      );
    },
    allowUpdateButton() {
      return !(this.bizInfo.certiStatus > 0 && this.bizInfo.agreeAll);
    },
  },
  methods: {
    closeWindow() {
      window.close();
    },
    changeTab(tabValue) {
      this.$store.commit("BizInfo/SET_TABVALUE", tabValue);
    },
    async clickUpdateBizInfo() {
      const message = this.certifyName();
      if (message) {
        this.$store.commit("BizInfo/SET_CRTMSG", message);
        return false;
      }

      this.$store.commit("BizInfo/SET_CRTMSG", "");
      await updateBizInfo({
        txvsreqpgmdivcd: TXVSREQPGMDIVCD.DATALINE,
        cporcd: CPORCD.BIZLINE,
        bizno: this.bizInfo.bizno,
        xmldata: this.getCftXmlData(),
        smt_ofcrnm: this.bizInfo.name,
        smt_ofcr_tel: this.bizInfo.tel,
      }).then(response => {
        if (response === "success") {
          alert("제출 완료되었습니다.");
          this.closeWindow();
        } else {
          alert("제출 실패하였습니다.");
        }
      });
    },
    certifyName() {
      const certifiedName = document.getElementById("certifiedName").value;
      let message = "";
      if (!certifiedName) {
        message = "PASS 인증을 완료해주세요.";
      } else if (this.bizInfo.name !== certifiedName) {
        message = "제출자명이 다릅니다.";
      }
      return message;
    },
    getCftXmlData() {
      const infoTypeList = this.bizInfo.infoTypeList;
      let bizXmlData = "";
      let finXmlData = "";

      infoTypeList.forEach(infoType => {
        let info = this.bizInfo[infoType];
        let type = info.type;
        if (info.checkStatus == 1 && type === "A1") {
          bizXmlData = info.xmldata;
        }
        if (info.checkStatus == 1 && type === "A2") {
          finXmlData += info.xmldata;
        }
      });

      const cftXmlData = createXml({ version: "1.0" }).ele("Data");
      if (bizXmlData) cftXmlData.ele("A1").ele(bizXmlData);
      if (finXmlData) cftXmlData.ele("A2").ele(finXmlData);
      return cftXmlData.end();
    },
  },
};
</script>

<style lang="" scoped></style>
